import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `EconomicIntegration` is a concrete implementation of `AbstractIntegration`
 * for integration with e-conomic.
 */
export default class EconomicIntegration extends AbstractIntegration {
	constructor({ hasAccessGrantToken } = {}) {
		super(...arguments);

		this._hasAccessGrantToken = hasAccessGrantToken;
	}

	isBeta() {
		return false;
	}

	getName() {
		return "e-conomic";
	}

	routeName() {
		return "economic";
	}

	isEconomicIntegration() {
		return true;
	}

	canHaveLinkedDocuments() {
		return this.hasAccessGrantToken();
	}

	hasAccessGrantToken() {
		return this._hasAccessGrantToken;
	}

	hasInvoiceSupport() {
		return true;
	}

	static getType() {
		return "EconomicIntegration";
	}
}
